import { render, staticRenderFns } from "./StarHead.vue?vue&type=template&id=55d8b05a&"
import script from "./StarHead.vue?vue&type=script&lang=js&"
export * from "./StarHead.vue?vue&type=script&lang=js&"
import style0 from "./StarHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d8b05a')) {
      api.createRecord('55d8b05a', component.options)
    } else {
      api.reload('55d8b05a', component.options)
    }
    module.hot.accept("./StarHead.vue?vue&type=template&id=55d8b05a&", function () {
      api.rerender('55d8b05a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/StarHead.vue"
export default component.exports